import { useQuery } from '@tanstack/react-query';
import { Profile, ProfileType } from '@ixicare/resources';
import { useStores } from '~store/utils';

// Profiles are still fetched by the int site id (the /profiles endpoint hasn't
// moved to uuid yet). Centralised here so the eventual id→uuid switch is a
// single change instead of one per assignment tab.
const PROFILE_QUERY_KEY: Partial<Record<ProfileType, string>> = {
  [ProfileType.HealthcareProvider]: 'hcps',
  [ProfileType.Resident]: 'residents',
};

export function useSiteProfiles(profileType: ProfileType) {
  const { sites } = useStores();
  const siteId = sites.selectedSite?.id;
  return useQuery({
    queryKey: [PROFILE_QUERY_KEY[profileType] ?? 'profiles', siteId],
    queryFn: () => Profile.getProfiles({ profileType, siteId }),
    enabled: !!siteId,
  });
}
